import { jsx as _jsx } from "react/jsx-runtime";
import { BackdropModal } from "../gallery/BackdropModal.js";
import { ThreeDViewer } from "./ThreeDViewer.js";
export function ThreeDViewModal({ modelUrl, handleClose, notInStack, arButtonTitle, }) {
    return (_jsx(BackdropModal, { handleClose: handleClose, notInStack: notInStack, children: _jsx(ThreeDViewer, { modelUrl: modelUrl, cameraControls: true, ar: true, autoRotate: true, arButtonTitle: arButtonTitle, fullScreen: true }) }));
}
//# sourceMappingURL=ThreeDViewModal.js.map